//
// flatpickr.js
//

import flatpickr from 'flatpickr';
import {Portuguese} from "flatpickr/dist/l10n/pt";

const toggles = document.querySelectorAll('[data-flatpickr]');

toggles.forEach((toggle) => {
    const options = toggle.dataset.flatpickr ? JSON.parse(toggle.dataset.flatpickr) : {};
    options.locale = Portuguese;
    options.dateFormat = 'd/m/Y';

    flatpickr(toggle, options);
});

// Make available globally
window.flatpickr = flatpickr;
